import runHeroSpotlight from './hero-spotlight';
import wallVariants from './wall-variants.json';
/* eslint-disable */
// Compiled section behaviors; globals are supplied by the owned lifecycle. No eval.
export default function runBehaviors(environment) {
const { document, window, matchMedia, requestAnimationFrame, cancelAnimationFrame, setTimeout, clearTimeout, setInterval, clearInterval, addEventListener, removeEventListener, IntersectionObserver, ResizeObserver, MutationObserver } = environment;
runHeroSpotlight(environment);

// Original section behavior 2

(()=>{
 const section=document.getElementById('mr-section-two');
 if(!section)return;
 const cardUpdates=[];
 section.querySelectorAll('.s2-panel').forEach(panel=>{
  const track=panel.querySelector('.s2-experiences');
  const cards=Array.from(track.children);
  const prev=panel.querySelector('[data-card-step="-1"]');
  const next=panel.querySelector('[data-card-step="1"]');
  const status=panel.querySelector('.s2-card-status');
  const update=()=>{
   if(panel.hidden)return;
   const step=cards[0].getBoundingClientRect().width+16;
   const index=Math.min(cards.length-1,Math.round(track.scrollLeft/step));
   status.textContent=String(index+1).padStart(2,'0')+' / 04';
   prev.disabled=index===0;
   next.disabled=index===cards.length-1;
  };
  panel.querySelectorAll('[data-card-step]').forEach(button=>button.addEventListener('click',()=>{
   track.scrollBy({left:Number(button.dataset.cardStep)*(cards[0].getBoundingClientRect().width+16),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }));
  track.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update);
  cardUpdates.push(update);update();
 });
 const tabs=Array.from(section.querySelectorAll('[role="tab"]'));
 const activate=(selected,focus=false)=>{
  tabs.forEach(tab=>{
   const active=tab===selected;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   document.getElementById(tab.getAttribute('aria-controls')).hidden=!active;
  });
  cardUpdates.forEach(update=>update());
  if(focus)selected.focus();
 };
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(tab));
  tab.addEventListener('keydown',event=>{
   let next;
   if(event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(tabs[next],true);
  });
 });
 if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;
 section.classList.add('s2-motion');
 const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('s2-visible');observer.unobserve(entry.target);}});},{threshold:.15,rootMargin:"0px 0px -24px 0px"});
 section.querySelectorAll('[data-s2-reveal]').forEach(element=>observer.observe(element));
})();

;
// Original section behavior 3

(()=>{const root=document.getElementById('devello-rest');if(!root||!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;root.classList.add('motion');const observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){entry.target.classList.add('visible');observer.unobserve(entry.target);}}},{threshold:.12,rootMargin:'0px 0px -20px 0px'});root.querySelectorAll('[data-d-reveal]').forEach(el=>observer.observe(el));})();

;
// Original section behavior 4

(()=>{
 const lists=[...document.querySelectorAll('.client-tags')];
 const fit=list=>{
  const names=[...list.querySelectorAll('.client-name')];
  const more=list.querySelector('.client-more');
  names.forEach(name=>name.hidden=false);
  const gap=parseFloat(getComputedStyle(list).columnGap)||0;
  const widths=names.map(name=>name.getBoundingClientRect().width+gap);
  const available=list.clientWidth;
  let width=more.getBoundingClientRect().width+widths.reduce((sum,value)=>sum+value,0);
  for(let i=names.length-1;i>=0 && width>available;i--){
   width-=widths[i];
   names[i].hidden=true;
  }
 };
 const observer=new ResizeObserver(entries=>entries.forEach(entry=>fit(entry.target)));
 lists.forEach(list=>{observer.observe(list);fit(list)});
 if(document.fonts) document.fonts.ready.then(()=>lists.forEach(fit));
})();
;
// Original section behavior 5
(() => {
 const root=document.getElementById('proof-projects');
 if(!root)return;
 const track=root.querySelector('.grid');
 const cards=[...track.querySelectorAll('.project')];
 const controls=document.createElement('div');
 controls.className='proof-slider-controls';
 controls.innerHTML='<button type="button" aria-label="이전 프로젝트 유형">←</button><span class="proof-slider-count" aria-live="polite"><b>01</b> / 06</span><button type="button" aria-label="다음 프로젝트 유형">→</button>';
 track.after(controls);
 const buttons=controls.querySelectorAll('button');
 const motion=matchMedia('(prefers-reduced-motion:reduce)');
 const mobile=matchMedia('(max-width:540px)');
 let index=0,step=0,frame=0,visible=false,touching=false,timer;
 const update=()=>{
  frame=0;
  const next=Math.max(0,Math.min(cards.length-1,Math.round(track.scrollLeft/step)));
  if(next===index)return;
  index=next;
  controls.querySelector('b').textContent=String(index+1).padStart(2,'0');
  buttons[0].disabled=index===0;buttons[1].disabled=index===cards.length-1;
 };
 const measure=()=>{step=cards[0].getBoundingClientRect().width+16;update();};
 const go=delta=>track.scrollTo({left:Math.max(0,Math.min(cards.length-1,index+delta))*step,behavior:motion.matches?'auto':'smooth'});
 const restart=()=>{
  clearInterval(timer);
  if(!visible||!mobile.matches||motion.matches||document.hidden||touching)return;
  timer=setInterval(()=>{if(!root.contains(document.activeElement))track.scrollTo({left:((index+1)%cards.length)*step,behavior:'smooth'});},2000);
 };
 buttons[0].disabled=true;
 buttons[0].onclick=()=>go(-1);buttons[1].onclick=()=>go(1);
 track.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(update);},{passive:true});
 new ResizeObserver(measure).observe(track);measure();
 track.addEventListener('pointerdown',()=>{touching=true;restart();},{passive:true});
 window.addEventListener('pointerup',()=>{if(touching){touching=false;restart();}},{passive:true});
 window.addEventListener('pointercancel',()=>{touching=false;restart();},{passive:true});
 buttons.forEach(button=>button.addEventListener('click',restart));
 new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;restart();},{rootMargin:'100px'}).observe(root);
 document.addEventListener('visibilitychange',restart);
 mobile.addEventListener('change',restart);motion.addEventListener('change',restart);
})();
;
// Original section behavior 6
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches || !('IntersectionObserver' in window)) return;
  const selector = [
    '.hero > h1', '.hero > p', '.hero .cta', '.hero .stats',
    '#mr-section-two .s2-heading', '#mr-section-two article',
    '#mr-section-three .s3-heading', '#mr-section-three article',
    '.k4-nav', '#k4-2 .intro', '#k4-2 .project',
    '.ed-heading', '.as-heading', '.as-stage', '.ed-recognition', '.ed-credentials', '.ed-channel', '.cp-channel', '.ed-review-feature', '.ed-review-notes', '.ed-process-layout', '.ed-planning-case', '.ed-offer', '.ed-offer-heading', '.ed-contact-layout', '.r-heading', '.r-hero .r-grid2 > *', '.r-hero > .r-wrap > div:not(.r-grid2)',
    '.r-block article', '.r-page main article', '.r-feature', '.r-repeat',
    '.r-origin-turn', '.r-origin-bridge', '.r-history-lead',
    '.r-principle-details', '.r-timeline-year > h2', '.r-timeline-case',
    '.r-compare', '.r-consult .r-wrap > *', '.r-library-controls',
    '.r-page form', '.r-empty', '.r-footer .r-wrap > *'
  ].join(',');
  const candidates = [...document.querySelectorAll(selector)];
  const selected = new Set(candidates);
  const nodes = candidates.filter(node => {
    for (let parent = node.parentElement; parent; parent = parent.parentElement) {
      if (selected.has(parent)) return false;
    }
    return true;
  });
  const reveal = node => {
    node.classList.add('mr-fade-visible');
    observer.unobserve(node);
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) reveal(entry.target); });
  }, {threshold: 0, rootMargin: '0px 0px -24px 0px'});
  nodes.forEach(node => {
    const siblings = node.parentElement ? [...node.parentElement.children] : [];
    node.style.setProperty('--mr-fade-delay', `${Math.max(0, siblings.indexOf(node) % 3) * 65}ms`);
    node.classList.add('mr-fade-item');
    observer.observe(node);
  });
  // Anchor navigation, keyboard focus and browser find must never land on hidden content.
  const revealContaining = target => {
    const item = target?.closest?.('.mr-fade-item');
    if (item) reveal(item);
    target?.querySelectorAll?.('.mr-fade-item').forEach(reveal);
  };
  const revealHash = () => {
    try { if (location.hash) revealContaining(document.getElementById(decodeURIComponent(location.hash.slice(1)))); }
    catch { /* Ignore malformed external fragment identifiers. */ }
  };
  addEventListener('hashchange', revealHash);
  addEventListener('focusin', event => revealContaining(event.target));
  addEventListener('beforeprint', () => nodes.forEach(reveal));
  reduce.addEventListener('change', event => {
    if (event.matches) { nodes.forEach(reveal); observer.disconnect(); }
  });
  revealHash();
})();

;
// Original section behavior 7
(() => {
  const root = document.querySelector('.authority-showcase');
  if (!root) return;
  const tabs = [...root.querySelectorAll('[role="tab"]')];
  const panels = [...root.querySelectorAll('[role="tabpanel"]')];
  let current = tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
  if (current < 0) current = 0;
 let timer;
 let visible = false;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const restart = () => {
    clearInterval(timer);
    if (!visible || document.hidden || motion.matches) return;
    timer = setInterval(() => {
      if (!document.hidden && !root.contains(document.activeElement)) {
        select((current + 1) % tabs.length);
      }
    }, 3000);
  };
  const select = (index, focus = false) => {
    const previous = current;
    current = index;
    panels.forEach(panel => panel.getAnimations().forEach(animation => animation.cancel()));
    tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
      panels[i].hidden = i !== index;
      panels[i].inert = i !== index;
      panels[i].setAttribute('aria-hidden', String(i !== index));
    });
    if (previous !== index && !motion.matches) {
      const outgoing = panels[previous];
      outgoing.hidden = false;
      outgoing.style.zIndex = '0';
      panels[index].style.zIndex = '1';
      const options = {duration: 650, easing: 'cubic-bezier(.22,.61,.36,1)'};
      outgoing.animate([{opacity:1},{opacity:0}], options).finished
        .then(() => { if (current !== previous) outgoing.hidden = true; })
        .catch(() => {});
      panels[index].animate([{opacity:0,transform:'translateX(10px)'},{opacity:1,transform:'translateX(0)'}], options);
    }
    if (focus) tabs[index].focus({preventScroll:true});
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      select(index);
      restart();
      if (matchMedia('(max-width: 680px)').matches) {
        panels[index].scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }
    });
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      select(next, true);
      restart();
    });
  });
  new IntersectionObserver(entries => {visible=entries[0].isIntersecting;restart();},{rootMargin:'100px'}).observe(root);
  document.addEventListener('visibilitychange',restart);
  motion.addEventListener('change',restart);
})();

;
// Original section behavior 8
(() => {
  const root = document.querySelector('#k4-5.content-proof');
  if (!root) return;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  if (motion.matches || !('IntersectionObserver' in window)) return;
  const formatter = new Intl.NumberFormat('ko-KR');
  const running = new Map();
  const finish = (card, frame) => {
    cancelAnimationFrame(frame);
    card.querySelectorAll('[data-count]').forEach(node => {
      node.textContent = formatter.format(Number(node.dataset.count));
    });
    running.delete(card);
  };
  const animate = card => {
    const counters = [...card.querySelectorAll('[data-count]')];
    let start;
    counters.forEach(node => { node.textContent = '0'; });
    const step = now => {
      start ??= now;
      let complete = true;
      counters.forEach((node, index) => {
        const progress = Math.min(1, Math.max(0, (now - start - index * 65) / 1500));
        const eased = 1 - Math.pow(1 - progress, 3);
        node.textContent = formatter.format(Math.round(Number(node.dataset.count) * eased));
        if (progress < 1) complete = false;
      });
      if (complete) running.delete(card);
      else running.set(card, requestAnimationFrame(step));
    };
    running.set(card, requestAnimationFrame(step));
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      animate(entry.target);
    });
  }, {threshold: 0.2});
  root.querySelectorAll('.cp-channel').forEach(card => observer.observe(card));
  motion.addEventListener('change', event => {
    if (!event.matches) return;
    observer.disconnect();
    running.forEach((frame, card) => finish(card, frame));
  });
  addEventListener('beforeprint', () => {
    observer.disconnect();
    running.forEach((frame, card) => finish(card, frame));
  });
})();

;
// Original section behavior 9
(() => {
  const root = document.querySelector('#k4-3.cw-proof');
  if (!root) return;
  const lanes = [...root.querySelectorAll('.cw-lane')];
  const originals = lanes.map(lane => [...lane.querySelector('.cw-group').children].map(card => card.cloneNode(true)));
  const makeClone = (node, className) => {
    const copy = node.cloneNode(true);
    copy.classList.add(className);
    copy.setAttribute('aria-hidden', 'true');
    copy.querySelectorAll('a,button').forEach(control => control.tabIndex = -1);
    return copy;
  };
  const build = () => lanes.forEach((lane, index) => {
    const track = lane.querySelector('.cw-track');
    lane.classList.remove('is-ready');
    track.replaceChildren();
    const group = document.createElement('div'); group.className = 'cw-group';
    originals[index].forEach(card => group.append(card.cloneNode(true)));
    track.append(group);
    let rounds = 0;
    while (group.getBoundingClientRect().width < lane.clientWidth + 420 && rounds++ < 8) {
      originals[index].forEach(card => group.append(makeClone(card, 'cw-filler')));
    }
    const gap = parseFloat(getComputedStyle(track).gap) || 20;
    const distance = group.getBoundingClientRect().width + gap;
    track.append(makeClone(group, 'cw-clone'));
    lane.style.setProperty('--cw-duration', `${distance / 35}s`);
    lane.classList.add('is-ready');
  });
  build();
  let width = root.clientWidth, resizeFrame;
  new ResizeObserver(() => {
    if (root.clientWidth === width) return;
    width = root.clientWidth;
    cancelAnimationFrame(resizeFrame); resizeFrame = requestAnimationFrame(build);
  }).observe(root);
  new IntersectionObserver(entries => root.classList.toggle('is-offscreen', !entries[0].isIntersecting), {rootMargin:'100px'}).observe(root);
})();

;
// Original section behavior 10
(()=>{
 const trigger=document.querySelector('.s3-inquiry-trigger');
 const modal=document.querySelector('#inquiry-modal');
 if(!trigger||!modal)return;
 const cases=[
  {src:'/homepage/assets/inquiries/inquiry-3.png',title:'운영·관리까지 고려한 사이트 재정비 문의'},
  {src:'/homepage/assets/inquiries/inquiry-4.png',title:'원하는 결과물이 나오지 않아 개발사 변경 문의'},
  {src:'/homepage/assets/inquiries/inquiry-6.png',title:'부실한 기획과 개발 지연으로 계약 해지 후 문의'},
  {src:'/homepage/assets/inquiries/inquiry-7.png',title:'개발자 연락 두절로 중단된 앱의 후속 개발 문의'},
  {src:'/homepage/assets/inquiries/inquiry-8.png',title:'반복된 출시 연기 이후 개발 인수·유지보수 문의'},
  {src:'/homepage/assets/inquiries/inquiry-9.png',title:'A/S 종료 이후 오류 수정과 추가 개발 문의'},
  {src:'/homepage/assets/inquiries/inquiry-10.png',title:'기존 사이트의 고도화·유지보수 문의'},
  {src:'/homepage/assets/inquiries/inquiry-11.png',title:'기존 유지보수 업체의 기술 대응 어려움으로 재정비 문의'}
 ];
 const img=modal.querySelector('.inquiry-image');
 const caption=modal.querySelector('.inquiry-caption'),count=modal.querySelector('.inquiry-count');
 const prev=modal.querySelector('[data-inquiry-prev]'),next=modal.querySelector('[data-inquiry-next]');
 const tabs=[...modal.querySelectorAll('[data-inquiry-index]')];
 let index=0,oldOverflow='';
 function show(n){index=Math.max(0,Math.min(cases.length-1,n));const item=cases[index];img.src=item.src;img.alt=item.title+'의 실제 문의 메일 (개인정보 가림)';caption.textContent=item.title;count.textContent=(index+1)+' / '+cases.length;prev.disabled=index===0;next.disabled=index===cases.length-1;tabs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));}
 trigger.addEventListener('click',()=>{show(0);oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';modal.showModal();});
 modal.querySelector('.inquiry-close').addEventListener('click',()=>modal.close());
 modal.addEventListener('close',()=>{document.body.style.overflow=oldOverflow;trigger.focus({preventScroll:true});});
 modal.addEventListener('click',e=>{if(e.target!==modal)return;const r=modal.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)modal.close();});
 prev.addEventListener('click',()=>show(index-1));next.addEventListener('click',()=>show(index+1));
 tabs.forEach(b=>b.addEventListener('click',()=>show(Number(b.dataset.inquiryIndex))));
 modal.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();show(index+1);}if(e.key==='ArrowLeft'){e.preventDefault();show(index-1);}});
})();

;
// Original section behavior 11
(() => {
 const selectors = [
  '#mrd-quality .mrd-quality__heading', '#mrd-quality .mrd-quality__description', '#mrd-quality .mrd-quality__rail',
  '#s5-intent .s5i-intent__head', '#s5-intent .s5i-pcard', '#s5-intent .s5i-case__head', '#s5-intent .s5i-chat', '#s5-intent .s5i-result',
  '#mrd-outro .mrd-spot__inner', '#mr-section-six .nx-heading', '#mr-section-six .nx-package', '#mr-section-six .nx-package-note',
  '#mr-section-eight .nx-contact-content', '.r-footer > *'
 ];
 document.querySelectorAll(selectors.join(',')).forEach(item => item.classList.add('nx-reveal'));
 const items = [...document.querySelectorAll('.nx-reveal')];
 const motion = matchMedia('(prefers-reduced-motion: reduce)');
 if (!items.length || !('IntersectionObserver' in window) || motion.matches) return;
 const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
   if (!entry.isIntersecting) return;
   entry.target.classList.add('nx-visible');
   observer.unobserve(entry.target);
  });
 }, {threshold:0, rootMargin:'0px 0px -6% 0px'});
 document.documentElement.classList.add('nx-motion');
 items.forEach(item => observer.observe(item));
 motion.addEventListener('change', () => {
  if (motion.matches) { observer.disconnect(); items.forEach(item => item.classList.add('nx-visible')); }
 });
})();

;
// Original section behavior 12
(() => {
  const desk = document.querySelector('[data-process-desk]');
  if (!desk) return;
  const nav = desk.querySelector('.s5-stage-nav');
  const tabs = [...nav.querySelectorAll('button[data-stage]')];
  const panels = [...desk.querySelectorAll('.s5-stage-panel')];
  nav.setAttribute('role', 'tablist');
  tabs.forEach(tab => tab.setAttribute('role', 'tab'));
  panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
  const select = (index, focus = false) => {
    tabs.forEach((tab, i) => {
      const selected = index === i;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      panels[i].hidden = !selected;
      panels[i].tabIndex = selected ? 0 : -1;
    });
    if (focus) tabs[index].focus();
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(index));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      select(next, true);
    });
  });
  select(1);
})();

;
// Original section behavior 13
(() => {
 const root = document.getElementById('s5-intent');
 if (!root) return;
 const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
 const chat = root.querySelector('#s5-intent-chat');
 const messages = [...chat.querySelectorAll('.s5i-msg')];
 let chatObserver;
 if ('IntersectionObserver' in window && !motion.matches) {
   chat.classList.add('s5i-chat--motion');
   chatObserver = new IntersectionObserver(entries => {
     entries.filter(e => e.isIntersecting).sort((a,b) => messages.indexOf(a.target) - messages.indexOf(b.target)).forEach((entry,i) => {
       entry.target.style.setProperty('--message-delay', `${i * 140}ms`);
       entry.target.classList.add('is-visible');
       chatObserver.unobserve(entry.target);
     });
   }, {threshold:.12, rootMargin:'0px 0px -16px 0px'});
   messages.forEach(message => chatObserver.observe(message));
 }
 motion.addEventListener('change', () => {
   if (motion.matches) {
     chatObserver?.disconnect();
     chat.classList.remove('s5i-chat--motion');
   }
 });
})();

;
// Original section behavior 14
(() => {
 const root = document.getElementById('s5-process');
 if (!root) return;
 const tabs = [...root.querySelectorAll('[role="tab"]')];
 const panels = [...root.querySelectorAll('[role="tabpanel"]')];
 const tablist = root.querySelector('[role="tablist"]');
 const vertical = window.matchMedia('(min-width: 1101px)');
 function orient() {tablist.setAttribute('aria-orientation', vertical.matches ? 'vertical' : 'horizontal');}
 orient(); vertical.addEventListener('change', orient);
 function select(index, focus = false) {
   tabs.forEach((tab, i) => {
     const selected = i === index;
     tab.classList.toggle('is-active', selected);
     tab.classList.toggle('is-done', i < index);
     tab.setAttribute('aria-selected', String(selected));
     tab.tabIndex = selected ? 0 : -1;
     panels[i].hidden = !selected;
   });
   if (focus) tabs[index].focus({preventScroll:true});
 }
 tabs.forEach((tab, index) => {
   tab.addEventListener('click', () => select(index));
   tab.addEventListener('keydown', event => {
     let next;
     if ((event.key === 'ArrowRight' || event.key === 'ArrowDown')) next = (index + 1) % tabs.length;
     if ((event.key === 'ArrowLeft' || event.key === 'ArrowUp')) next = (index - 1 + tabs.length) % tabs.length;
     if (event.key === 'Home') next = 0;
     if (event.key === 'End') next = tabs.length - 1;
     if (next === undefined) return;
     event.preventDefault(); select(next, true);
   });
 });
 const wall = root.querySelector('.s5p-wall');
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 if ('IntersectionObserver' in window && !reduced) {
   root.classList.add('s5p-motion');
   const observer = new IntersectionObserver(entries => {
     if (entries.some(entry => entry.isIntersecting)) {
       wall.classList.add('is-in'); observer.disconnect();
     }
   }, {threshold: .15});
   observer.observe(wall);
 } else wall.classList.add('is-in');
})();

;
// Original section behavior 15

(function () {
  var stage = document.querySelector('[data-mrd-spot]');
  if (!stage) return;
  var section = stage.closest('.mrd-spot');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var APPS = [{"name": "powderroom", "src": "/homepage/assets/outro-apps/powderroom.png", "width": 375, "height": 1448, "featured": true}, {"name": "lg-hellovision", "src": "/homepage/assets/outro-apps/lg-hellovision.png", "width": 375, "height": 7217, "featured": true}, {"name": "hyundai-hmg", "src": "/homepage/assets/outro-apps/hyundai-hmg.png", "width": 360, "height": 5274, "featured": true}, {"name": "paradise", "src": "/homepage/assets/outro-apps/paradise.png", "width": 320, "height": 568, "featured": true}, {"name": "dear-monday", "src": "/homepage/assets/outro-apps/dear-monday.png", "width": 360, "height": 2185, "featured": true}, {"name": "museum", "src": "/homepage/assets/outro-apps/museum.png", "width": 375, "height": 5240, "featured": false}, {"name": "celegram", "src": "/homepage/assets/outro-apps/celegram.png", "width": 375, "height": 3366, "featured": false}, {"name": "career-scan-report", "src": "/homepage/assets/outro-apps/career-scan-report.png", "width": 1050, "height": 1480, "featured": false}, {"name": "pogeun", "src": "/homepage/assets/outro-apps/pogeun.png", "width": 375, "height": 2693, "featured": false}, {"name": "seda", "src": "/homepage/assets/outro-apps/seda.png", "width": 375, "height": 3378, "featured": false}, {"name": "kmdb", "src": "/homepage/assets/outro-apps/kmdb.png", "width": 375, "height": 812, "featured": false}, {"name": "kofa", "src": "/homepage/assets/outro-apps/kofa.png", "width": 375, "height": 3849, "featured": false}, {"name": "phone-nation", "src": "/homepage/assets/outro-apps/phone-nation.png", "width": 375, "height": 1691, "featured": false}, {"name": "atrasan", "src": "/homepage/assets/outro-apps/atrasan.png", "width": 300, "height": 4278, "featured": false}, {"name": "career-scan", "src": "/homepage/assets/outro-apps/career-scan.png", "width": 748, "height": 1330, "featured": false}, {"name": "computer-study", "src": "/homepage/assets/outro-apps/computer-study.png", "width": 736, "height": 1322, "featured": false}, {"name": "shortiesoo", "src": "/homepage/assets/outro-apps/shortiesoo.png", "width": 740, "height": 1320, "featured": false}, {"name": "powderroom-magazine", "src": "/homepage/assets/outro-apps/powderroom-magazine.webp", "width": 375, "height": 3450, "featured": false}, {"name": "museum-intro", "src": "/homepage/assets/outro-apps/museum-intro.webp", "width": 375, "height": 3003, "featured": false}, {"name": "koaa-themes", "src": "/homepage/assets/outro-apps/koaa-themes.webp", "width": 375, "height": 4024, "featured": false}, {"name": "jollypot-home", "src": "/homepage/assets/outro-apps/jollypot-home.webp", "width": 390, "height": 4336, "featured": false}, {"name": "powderroom-awards", "src": "/homepage/assets/outro-apps/powderroom-awards.webp", "width": 375, "height": 3606, "featured": false}, {"name": "celelink", "src": "/homepage/assets/outro-apps/celelink.webp", "width": 225, "height": 4096, "featured": false}, {"name": "kmdb-films", "src": "/homepage/assets/outro-apps/kmdb-films.webp", "width": 265, "height": 4096, "featured": false}, {"name": "koaa-modernism", "src": "/homepage/assets/outro-apps/koaa-modernism.webp", "width": 375, "height": 1211, "featured": false}, {"name": "pogeun-cafe", "src": "/homepage/assets/outro-apps/pogeun-cafe.webp", "width": 375, "height": 1728, "featured": false}, {"name": "jollypot-recipe", "src": "/homepage/assets/outro-apps/jollypot-recipe.webp", "width": 390, "height": 3110, "featured": false}, {"name": "seda-archive", "src": "/homepage/assets/outro-apps/seda-archive.webp", "width": 375, "height": 812, "featured": false}, {"name": "kofa-exhibition", "src": "/homepage/assets/outro-apps/kofa-exhibition.webp", "width": 375, "height": 3601, "featured": false}, {"name": "computer-study-home", "src": "/homepage/assets/outro-apps/computer-study-home.webp", "width": 375, "height": 3991, "featured": false}, {"name": "koaa-home", "src": "/homepage/assets/outro-apps/koaa-home.webp", "width": 281, "height": 4096, "featured": false}, {"name": "celegram-profile", "src": "/homepage/assets/outro-apps/celegram-profile.webp", "width": 316, "height": 4096, "featured": false}];
  var grid = section.querySelector('[data-mrd-wall]');
  section.classList.add('is-offscreen', 'is-wall-offscreen');
  var priority = APPS.filter(function (app) { return app.featured; });
  var supporting = APPS.filter(function (app) { return !app.featured; });
  function setScreen(card, app) {
    card.dataset.screen = app.name;
    const img = card.querySelector('img');
    const variant = wallVariants[app.src];
    const url = variant ? variant.url : app.src;
    if (section.dataset.mediaReady === 'true') img.src = url;
    else img.dataset.deferSrc = url;
  }
  function buildWall() {
    if (!grid || grid.childElementCount) return;
    section.dataset.mediaReady = 'true';
    var fragment = document.createDocumentFragment();
    // Keep the original 96-cell wall geometry and pixel speed.
    // Each complete 32-screen cycle contains no duplicate sources.
    for (var cycle = 0; cycle < 3; cycle++) {
      for (var i = 0; i < APPS.length; i++) {
        var card = document.createElement('div');
        card.className = 'mrd-app';
        var img = document.createElement('img');
        img.className = 'mrd-app__screen';
        img.alt = '';
        img.width = 288;
        img.height = 624;
        img.decoding = 'async';
        img.loading = 'lazy';
        img.draggable = false;
        card.appendChild(img);
        fragment.appendChild(card);
      }
    }
    grid.appendChild(fragment);
    // Fill the existing center cells with the initial five, then distribute every
    // remaining screen once. Repeat only the complete cycle for a seamless loop.
    var bounds = section.getBoundingClientRect();
    var centerX = bounds.left + bounds.width / 2;
    var centerY = bounds.top + bounds.height / 2;
    var cards = Array.prototype.slice.call(grid.children);
    var cells = cards.map(function (card, index) {
      var rect = card.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      return {index:index, x:cx, distance:Math.hypot(cx - centerX, cy - centerY)};
    }).sort(function (a, b) { return a.distance - b.distance; });
    var chosen = [];
    cells.forEach(function (cell) {
      if (chosen.length < priority.length && !chosen.some(function (other) { return other.index % APPS.length === cell.index % APPS.length; })) chosen.push(cell);
    });
    var sequence = new Array(APPS.length);
    chosen.sort(function (a, b) { return a.x - b.x; }).forEach(function (cell, index) {
      sequence[cell.index % APPS.length] = priority[index];
      cards[cell.index].dataset.initialCenter = 'true';
    });
    var next = 0;
    for (var slot = 0; slot < sequence.length; slot++) {
      if (!sequence[slot]) sequence[slot] = supporting[next++];
    }
    cards.forEach(function (card, index) {
      setScreen(card, sequence[index % sequence.length]);
    });
  }

  // Prepare the 96-card wall near the section, not during initial hydration.
  if (grid && 'IntersectionObserver' in window) {
    var prepareWall = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      prepareWall.disconnect();
      setTimeout(buildWall, 0);
    }, {rootMargin:'1200px'});
    prepareWall.observe(section);
  } else buildWall();

  // Reveal the closing thought line by line as it enters the viewport.
  var closingCopy = section.querySelector('.mrd-spot__sub');
  if (closingCopy && !reduce && 'IntersectionObserver' in window) {
    Array.prototype.forEach.call(closingCopy.children, function (line, index) {
      line.style.setProperty('--copy-delay', (index * 150) + 'ms');
    });
    closingCopy.classList.add('mrd-copy-motion');
    var copyReveal = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          closingCopy.classList.add('is-visible');
          copyReveal.unobserve(closingCopy);
        }
      });
    }, {threshold:0.25});
    copyReveal.observe(closingCopy);
  }

  var ox = 0, oy = 0;
  var w = 0, h = 0;          // 무대 크기
  var x = 0, y = 0;          // 현재 빛 위치
  var tx = 0, ty = 0;        // 목표 위치
  var t = 0, last = 0;       // 자동 이동용 시간
  var manual = false;        // 사용자가 직접 움직이는 중인지
  var raf = 0, running = false;
  var stageVisible = false;
  var shade = section.querySelector('.mrd-shade--spot');

  function measure() {
    var r = stage.getBoundingClientRect();
    var sectionRect = section.getBoundingClientRect();
    ox = r.left - sectionRect.left;
    oy = r.top - sectionRect.top;
    w = r.width;
    h = r.height;
  }

  // 두 번째 글자('뢰'→'도') 위치: 정지 상태일 때 빛을 여기에 둡니다
  function focusPoint() {
    var pad = parseFloat(getComputedStyle(stage).paddingLeft) || 0;
    var charW = (w - pad * 2) / 6;
    return { x: pad + charW * 1.5, y: h / 2 };
  }

  function apply(px, py) {
    stage.style.setProperty('--mx', px.toFixed(1) + 'px');
    stage.style.setProperty('--my', py.toFixed(1) + 'px');
    // Local variables avoid invalidating all 96 image cards on every frame.
    shade.style.setProperty('--sx', (ox + px).toFixed(1) + 'px');
    shade.style.setProperty('--sy', (oy + py).toFixed(1) + 'px');
  }

  function tick(now) {
    raf = requestAnimationFrame(tick);
    if (last && now - last < 1000 / 60 - 1) return;
    var dt = last ? Math.min(50, now - last) : 16;
    last = now;
    if (!manual) {
      t += dt * 0.001;
      tx = w * (0.5 + 0.40 * Math.sin(t * 0.9));
      ty = h * (0.5 + 0.22 * Math.sin(t * 1.7));
    }
    var k = 1 - Math.pow(0.86, dt / 16);   // 프레임 속도와 무관한 부드러운 추적
    x += (tx - x) * k;
    y += (ty - y) * k;
    apply(x, y);
  }

  function start() {
    section.classList.remove('is-offscreen');
    if (running || reduce || document.hidden) return;
    running = true;
    last = 0;
    raf = requestAnimationFrame(tick);
  }
  function stop() {
    section.classList.add('is-offscreen');
    running = false;
    cancelAnimationFrame(raf);
  }

  function pointer(e) {
    var r = stage.getBoundingClientRect();
    tx = e.clientX - r.left;
    ty = e.clientY - r.top;
    manual = true;
    section.classList.add('is-touched');
    if (reduce) apply(tx, ty);
  }
  function release() {
    manual = false;
    if (reduce) { var p = focusPoint(); apply(p.x, p.y); }
  }

  measure();
  var p0 = focusPoint();
  x = tx = p0.x;
  y = ty = p0.y;
  // 자동 이동이 두 번째 글자 근처에서 시작하도록 시간 오프셋을 맞춥니다
  t = Math.asin(Math.max(-1, Math.min(1, (p0.x / w - 0.5) / 0.40))) / 0.9;
  apply(x, y);

  stage.addEventListener('pointermove', pointer);
  stage.addEventListener('pointerdown', pointer);
  stage.addEventListener('pointerleave', release);
  stage.addEventListener('pointercancel', release);

  window.addEventListener('resize', function () {
    measure();
    if (reduce || !running) { var p = focusPoint(); apply(p.x, p.y); }
  });

  // Keep the original image wall moving throughout the full outro and CTA.
  var wallVisible = false;
  function updateWall() {
    section.classList.toggle('is-wall-offscreen', !wallVisible || document.hidden);
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      wallVisible = entries[0].isIntersecting;
      updateWall();
    }, {threshold:0}).observe(section);
  } else {
    wallVisible = true;
    updateWall();
  }
  document.addEventListener('visibilitychange', updateWall);

  // 화면에 보일 때만 애니메이션을 돌립니다
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stageVisible = entries[0].isIntersecting;
      stageVisible && !document.hidden ? start() : stop();
    }, { threshold: 0.15 }).observe(stage);
  } else {
    stageVisible = true;
    start();
  }
  document.addEventListener('visibilitychange', function () { stageVisible && !document.hidden ? start() : stop(); });

  // 웹폰트 로딩 후 크기가 바뀌므로 다시 측정
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      measure();
      if (reduce) { var p = focusPoint(); apply(p.x, p.y); }
    });
  }
})();


;
// Original section behavior 16
(() => {
 const root = document.getElementById('mrd-quality');
 if (!root) return;
 const cases = JSON.parse(root.querySelector('[data-quality-cases]').textContent);
 const phones = [...root.querySelectorAll('[data-quality-index]')];
 const rail = root.querySelector('.mrd-quality__rail');
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const logo = root.querySelector('[data-quality-logo]');
 const logoWrap = logo.parentElement;
 const title = root.querySelector('[data-quality-title]');
 const description = root.querySelector('[data-quality-description]');
 const count = root.querySelector('[data-quality-count]');
 const detailIcons = {
  collection: '<rect x="2" y="3" width="10" height="12" rx="1"/><path d="M5 6h4M5 9h3"/><circle cx="12" cy="11" r="3.5"/><path d="m14.5 13.5 2.5 2.5"/>',
  exhibition: '<rect x="1.5" y="3" width="15" height="12" rx="1.5"/><circle cx="6" cy="7" r="1.5"/><path d="m3 13 4-4 3 3 2-2 3 3"/>',
  history: '<circle cx="9" cy="9" r="6.5"/><path d="M9 5v4l3 2M1 4v4h4"/>',

  reference: '<circle cx="6" cy="5" r="2.5"/><path d="M1.5 15v-2a4.5 4.5 0 0 1 9 0v2M12 3a2.5 2.5 0 0 1 0 5m1 2a4 4 0 0 1 3.5 4v1"/>',
  radar: '<path d="m9 1 7.5 5.5-3 9H4.5l-3-9L9 1Zm0 4 4 3-1.5 5H6L4.5 8 9 5Zm0-4v8m7.5-2.5L9 9m4.5 6.5L9 9m-4.5 6.5L9 9M1.5 6.5 9 9"/>',
  report: '<path d="M4 1h7l4 4v12H4V1Zm7 0v4h4M7 8h5M7 11h5M7 14h3"/>',

  sparkles: '<path d="m8 2 1.6 4.4L14 8l-4.4 1.6L8 14 6.4 9.6 2 8l4.4-1.6L8 2Z"/><path d="M14 1v4M12 3h4"/>',
  trophy: '<path d="M5 2h8v4a4 4 0 0 1-8 0V2Z"/><path d="M5 3H2v2a3 3 0 0 0 3 3m8-5h3v2a3 3 0 0 1-3 3M9 10v4m-3 2h6M7 14h4"/>',
  gift: '<path d="M3 8h12v8H3V8ZM2 5h14v3H2V5Zm7 0v11"/><path d="M9 5H6a2 2 0 1 1 2-2l1 2Zm0 0h3a2 2 0 1 0-2-2L9 5Z"/>',
  quote: '<rect x="4" y="2" width="10" height="14" rx="2"/><path d="M7 5h4M7 8h4M7 11h2M8 14h2"/>',
  compare: '<path d="M2 5h13m-3-3 3 3-3 3M16 13H3m3-3-3 3 3 3"/>',
  chat: '<path d="M15.5 8a6.5 6.5 0 0 1-6.5 6.5H6l-4 2v-5A6.5 6.5 0 1 1 15.5 8Z"/><path d="M6 8h.01M9 8h.01M12 8h.01"/>',
  learning: '<path d="M9 4C6 2 3 2 1.5 3v11c2-1 4.5-1 7.5 1 3-2 5.5-2 7.5-1V3C15 2 12 2 9 4Zm0 0v11"/><path d="m4 6 2 1m6 0 2-1M4 9l2 1m6 0 2-1"/>',
  classroom: '<rect x="2" y="2" width="14" height="10" rx="1.5"/><path d="M9 12v4m-3 0h6M5 8l3-3 2 2 3-3"/>',
  'cloud-record': '<path d="M4 12a3 3 0 0 1-.5-6 5 5 0 0 1 9.6-.8A3.5 3.5 0 0 1 14.5 12"/><path d="M6 9h6v7H6V9Zm2 2h2m-2 2h2"/>'
 };
 function detailTag(text, icon) {
  const tag = document.createElement('span');
  if (detailIcons[icon]) {
   tag.classList.add('has-icon');
   const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
   svg.setAttribute('viewBox','0 0 18 18');
   svg.setAttribute('aria-hidden','true');
   svg.innerHTML = detailIcons[icon];
   tag.append(svg);
  }
  tag.append(document.createTextNode(text));
  return tag;
 }
 let active = 0, visible = false;
 function play() {
  phones.forEach((phone,i) => {
   const video = phone.querySelector('video');
   if (i !== active || !visible || reduced.matches || document.hidden) {video.pause();return;}
   if (!video.getAttribute('src')) {video.src = video.dataset.src;video.load();}
   video.muted = true;
   video.play().catch(() => {});
  });
 }
 function position() {
  const computed = getComputedStyle(root);
  const phoneWidth = parseFloat(computed.getPropertyValue('--phone-w'));
  const step = parseFloat(computed.getPropertyValue('--phone-step'));
  phones.forEach((phone,i) => {
   let relative = (i - active + phones.length) % phones.length;
   if (relative === phones.length - 1) relative = -1;
   phone.style.setProperty('--x', (relative === 0 ? 0 : relative < 0 ? -phoneWidth - 40 : phoneWidth + 20 + (relative - 1) * step) + 'px');
   phone.style.setProperty('--scale',relative === 0 ? '1' : '.8');
   phone.style.opacity = relative < 0 || relative > 3 ? '0' : '1';
   phone.style.pointerEvents = relative < 0 || relative > 3 ? 'none' : '';
  });
 }
 function select(index) {
  const next = (index + cases.length) % cases.length;
  const changed = next !== active;
  active = next;
  phones.forEach((phone,i) => {
   phone.classList.toggle('is-active',i === active);
   phone.setAttribute('aria-pressed',String(i === active));
   phone.tabIndex = i === active ? 0 : -1;
   if (i !== active) {phone.querySelector('video').pause();phone.classList.remove('is-playing');}
  });
  const data = cases[active];
  logoWrap.hidden = !data.logo;
  if (data.logo) {
   logo.src = data.logo;logo.alt = data.title;
   logo.style.setProperty('--quality-logo-scale', data.logoScale ?? 1);
   if (!logo.isConnected) logoWrap.append(logo);
  } else {
   logoWrap.replaceChildren();
   logo.removeAttribute('src');
  }
  title.textContent = data.title;description.textContent = data.description;
  root.style.setProperty('--case-accent',data.accent);
  root.querySelector('[data-quality-details]').replaceChildren(...data.details.map((text,i) => detailTag(text,data.detailIcons?.[i])));
  count.textContent = String(active + 1).padStart(2,'0');
  if (changed) {
   const copy = root.querySelector('.mrd-quality__copy');
   if (!reduced.matches) copy.animate([{opacity:0,transform:'translateY(10px)'},{opacity:1,transform:'translateY(0)'}],{duration:300});
   const video = phones[active].querySelector('video');
   phones[active].style.setProperty('--progress','0');
   if (video.getAttribute('src')) video.currentTime = 0;
  }
  position();play();
 }
 root.querySelector('[data-quality-prev]').addEventListener('click',() => select(active - 1));
 root.querySelector('[data-quality-next]').addEventListener('click',() => select(active + 1));
 phones.forEach((phone,i) => {
  phone.addEventListener('click',() => select(i));
  const video = phone.querySelector('video');
  video.addEventListener('playing',() => phone.classList.add('is-playing'));
  video.addEventListener('timeupdate',() => {if(i === active && Number.isFinite(video.duration) && video.duration > 0) phone.style.setProperty('--progress',String(Math.min(1,video.currentTime / video.duration)));});
  video.addEventListener('ended',() => {if (i === active && visible && !reduced.matches) select(active + 1);});
 });
 rail.addEventListener('keydown',event => {
  if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
  event.preventDefault();
  select(event.key === 'Home' ? 0 : event.key === 'End' ? cases.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
 });
 let start = null, suppressClick = false;
 rail.addEventListener('pointerdown',event => {if(event.isPrimary && event.button === 0)start = {x:event.clientX,y:event.clientY};});
 rail.addEventListener('pointerup',event => {
  if (!start) return;
  const dx = event.clientX - start.x, dy = event.clientY - start.y;
  start = null;
  if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {suppressClick = true;select(active + (dx < 0 ? 1 : -1));}
 });
 rail.addEventListener('pointercancel',() => {start = null;});
 rail.addEventListener('click',event => {if(suppressClick){event.stopImmediatePropagation();event.preventDefault();suppressClick=false;}},true);
 const observer = new IntersectionObserver(entries => {visible=entries[0].isIntersecting;play();},{threshold:.15});
 observer.observe(rail);
 document.addEventListener('visibilitychange',play);
 reduced.addEventListener('change',play);
 window.addEventListener('resize',position);
 select(0);
})();

;
// Original section behavior 17
(() => {
  const root = document.querySelector('#mr-section-three.mrs3');
  if (!root) return;
  const crowd = root.querySelector('.mrs3-crowd');
  const head = root.querySelector('.mrs3-head');
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  // Keep native disclosure semantics while easing the container's actual height.
  root.querySelectorAll('details.mrs3-bar').forEach(panel => {
    const summary = panel.querySelector('summary');
    const copy = panel.querySelector('.mrs3-detail');
    let expanded = panel.open;
    let heightAnimation = null;
    let copyAnimation = null;
    summary.addEventListener('click', event => {
      event.preventDefault();
      expanded = !expanded;
      const from = panel.getBoundingClientRect().height;
      if (heightAnimation) {heightAnimation.onfinish = null;heightAnimation.cancel();}
      if (copyAnimation) copyAnimation.cancel();
      if (motion.matches || !panel.animate) {
        panel.open = expanded;panel.style.removeProperty('height');panel.style.removeProperty('overflow');return;
      }
      panel.style.height = 'auto';
      panel.open = true;
      const border = getComputedStyle(panel);
      const to = expanded ? panel.getBoundingClientRect().height : summary.getBoundingClientRect().height + parseFloat(border.borderTopWidth) + parseFloat(border.borderBottomWidth);
      panel.style.height = from + 'px';
      panel.style.overflow = 'hidden';
      heightAnimation = panel.animate([{height:from+'px'},{height:to+'px'}],{duration:380,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'});
      copyAnimation = copy.animate(expanded ? [{opacity:0,transform:'translateY(-6px)'},{opacity:1,transform:'none'}] : [{opacity:1},{opacity:0}],{duration:expanded?300:180,fill:'both'});
      heightAnimation.onfinish = () => {
        panel.open = expanded;
        panel.style.removeProperty('height');panel.style.removeProperty('overflow');
        heightAnimation.cancel();heightAnimation = null;
        copyAnimation.cancel();copyAnimation = null;
      };
    });
  });
  const chips = [...crowd.querySelectorAll('.mrs3-chip')];
  const fraction = n => { const value = Math.sin(n * 12.9898 + 78.233) * 43758.5453; return value - Math.floor(value); };
  chips.forEach((chip, index) => {
    const rain = document.createElement('span');
    rain.className = 'mrs3-rain';
    const duration = 9 + fraction(index + 1) * 5;
    rain.style.setProperty('--rain-duration', duration.toFixed(2) + 's');
    rain.style.setProperty('--rain-delay', (-fraction(index + 9) * duration).toFixed(2) + 's');
    rain.style.setProperty('--rain-start', (fraction(index + 41) * 24 - 12).toFixed(1) + 'deg');
    rain.style.setProperty('--rain-end', (fraction(index + 61) * 24 - 12).toFixed(1) + 'deg');
    rain.style.setProperty('--rain-drift', (fraction(index + 81) * 36 - 18).toFixed(1) + 'px');
    rain.style.setProperty('--rain-static', (fraction(index + 101) * 90).toFixed(1) + '%');
    chip.before(rain);
    rain.appendChild(chip);
  });
  // Fit complete labels, including their rotation and drift, inside the section.
  const measure = () => {
    const sectionRect = root.getBoundingClientRect();
    const headRect = head.getBoundingClientRect();
    const edge = sectionRect.width <= 760 ? 8 : 20;
    [crowd, root.querySelector('.mrs3-veil')].forEach(layer => {
      layer.style.left = (sectionRect.left - headRect.left + edge) + 'px';
      layer.style.width = (sectionRect.width - edge * 2) + 'px';
      layer.style.right = 'auto';
    });
    chips.forEach((chip, index) => {
      const rain = chip.parentElement;
      const safe = 26;
      const available = Math.max(0, crowd.clientWidth - chip.offsetWidth - safe * 2);
      rain.style.setProperty('--rain-x', (safe + fraction(index + 21) * available).toFixed(1) + 'px');
      // Several shallow layers make a soft pile without covering the headline.
      const land = crowd.clientHeight - 56 - fraction(index + 121) * 66;
      rain.style.setProperty('--rain-land', land.toFixed(1) + 'px');
      rain.style.setProperty('--rain-static', land.toFixed(1) + 'px');
    });
  };
  measure();
  if (document.fonts) document.fonts.ready.then(measure);
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(crowd);
  else window.addEventListener('resize', measure, {passive:true});
  let headVisible = false;
  const updateRain = () => root.classList.toggle('is-raining', headVisible && !document.hidden && !motion.matches);
  const items = [...root.querySelectorAll('.mrs3-row, .mrs3-result')];
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      entries.forEach(entry => {headVisible = entry.isIntersecting;});
      updateRain();
    }).observe(head);
    if (!motion.matches) {
      root.classList.add('is-js');
      const reveal = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {entry.target.classList.add('is-in');reveal.unobserve(entry.target);}
        });
      }, {threshold:.18});
      items.forEach(item => reveal.observe(item));
    }
  } else {
    headVisible = true;
    updateRain();
  }
  motion.addEventListener('change', () => {
    updateRain();
    if (motion.matches) items.forEach(item => item.classList.add('is-in'));
  });
  document.addEventListener('visibilitychange', updateRain);
})();

}
